export const CaseStatusComparisonFormBoxes = [
  {
    name: 'periods',
    inputBoxes: {
      fromDate: {
        label: 'From Date',
        name: 'fromDate',
        width: '226px',
        placeholder: 'mm/dd/yyyy',
        isMandatory: true,
        isDatePicker: true,
        height: '48px',
      },
      toDate: {
        label: 'To Date',
        name: 'toDate',
        width: '226px',
        placeholder: 'mm/dd/yyyy',
        isMandatory: true,
        isDatePicker: true,
        height: '48px',
      },
    },
  },
  {
    name: 'statesAndStatuses',
    inputBoxes: [
      {
        label: 'State(s)',
        name: 'stateCodes',
        placeholder: '-',
        width: '226px',
        isCheckboxSelect: true,
        isMandatory: true,
      },
      {
        label: 'Status(es)',
        name: 'caseStatuses',
        placeholder: '-',
        width: '226px',
        isCheckboxSelect: true,
        isMandatory: true,
      },
    ],
  },
];

export const stateCodesOptions = [
  { value: 'AZ', label: 'AZ' },
  { value: 'NV', label: 'NV' },
  { value: 'NM', label: 'NM' },
];
